import { machToggleLoadingScreen } from "./main";

jQuery(document).ready(function () {
    jQuery(".search-algolia-listing form").on("submit", function (e) {
        e.preventDefault();
        machRefreshSearch();
    });

    jQuery("#search-popup .see-more-btn").on("click", function () {
        let $content = jQuery(this).siblings(".search-content");
        $content.addClass("show-all");
        $content.removeClass("show-gradient");
        $content.addClass("hide-gradient");
        jQuery(this).addClass("hidden");
    });

    jQuery(".search-algolia-listing input[type='search']").on("input", function () {
        const searchContainers = {
            stores: jQuery("#search-stores"),
            services: jQuery("#search-services"),
            promotions: jQuery("#search-promotions"),
            news_events: jQuery("#search-news-events"),
            blog_posts: jQuery("#search-blog"),
        };

        if (!this.value) {
            Object.values(searchContainers).forEach((container) => container.hide().find(".search-content").empty());
            jQuery("#search-popup .see-more-btn").addClass("hidden");
            jQuery(".search-results-container").removeClass("flex");
            jQuery(".search-results-container").addClass("hidden");
        }
    });
});

/**
 * Function making an AJAX request in order to refresh the content based on the filters.
 */
function machRefreshSearch() {
    const searchInput = jQuery('#search-popup input[type="search"]').val().trim();

    if (!searchInput) {
        Object.values(searchContainers).forEach((container) => container.hide().find(".search-content").empty());
        jQuery("#search-popup .see-more-btn, .no-results").addClass("hidden");
        return;
    }

    const searchContainers = {
        stores: jQuery("#search-stores"),
        services: jQuery("#search-services"),
        promotions: jQuery("#search-promotions"),
        news_events: jQuery("#search-news-events"),
        blog_posts: jQuery("#search-blog"),
    };

    Object.values(searchContainers).forEach((container) => {
        container.hide().find(".search-content").empty();
    });

    jQuery("#search-popup .see-more-btn").addClass("hidden");
    jQuery("#search-popup .no-results").addClass("hidden");

    jQuery.ajax({
        url: backendInfo.ajaxurl,
        type: "GET",
        data: {
            action: "mach_filtered_search",
            search_query: searchInput,
        },
        beforeSend: function () {
            machToggleLoadingScreen();
        },
        success: function (result) {
            let data = JSON.parse(result);

            if (data.results.length === 0) {
                jQuery("#search-popup .no-results").removeClass("hidden");
            } else {
                Object.values(searchContainers).forEach((container) => container.hide().find(".search-content").empty());

                data.results.forEach((item) => {
                    let url = item.url;
                    // Handle post types that don't have a defined page
                    if (item.content_type === "services") {
                        url = backendInfo.service_page_url + "#" + item.objectID;
                    }
                    if (item.content_type === "promotions") {
                        url = backendInfo.promotion_page_url + "?popup=" + item.objectID;
                    }

                    let resultItem = `<div class="result-item"><a href="${url}" target="_blank">${item.title}</a></div>`;
                    let $container = searchContainers[item.content_type] || null;

                    if ($container) {
                        machAddSearchResult($container, resultItem);
                    }
                });
            }

            machToggleLoadingScreen();
        },
    });
}

/**
 * Add results to the result container
 * @param {*} $container
 * @param {*} resultItem
 */
function machAddSearchResult($container, resultItem) {
    jQuery(".search-results-container").removeClass("hidden").addClass("flex");
    $container.css("display", "flex").find(".search-content").append(resultItem);

    if ($container.find(".result-item").length > 5) {
        $container.find(".search-content").removeClass("hide-gradient");
        $container.find(".search-content").addClass("show-gradient");
        $container.find(".see-more-btn").removeClass("hidden");
    }
}
